import { DOOH_REPORT_CAMPAIGN } from './config';

const reducer = (state = null, action) => {
    switch (action.type) {
        case DOOH_REPORT_CAMPAIGN:
            return action.payload;
        
        default:
            return state;
    }
}

export default reducer;